import { cn } from "@utils/tailwind-merge"





export interface MountingProps{
  className?: string
}


export function Mounting(props: MountingProps) {


  return (
    <section 
      className={cn(
        "h-full w-full bg-secondary-base flex items-center justify-center animate-shimmer", 
        // "bg-[linear-gradient(110deg,#000103,45%,#1e2631,55%,#000103)] bg-[length:200%_100%]",
        "bg-[linear-gradient(90deg,#1852E7,45%,#5484ff,55%,#1852E7)] bg-[length:200%_100%]",
        props.className
      )}
    >
    </section>
  )
}
